<template>
  <gc-main-layout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :tabs="tabs"
    :selectedIndex="selectedIndex"
    :baseView="baseView"
    :key="baseView.mode"
    :formsConfig="formsConfig"
  >
    <template #headerContent>
      <GcHeaderContentStatic title="Production Settings" />
    </template>
    <div>
      <gc-split-view
        :showLeftContainer="showLeftContainer"
        :showRightContainer="showRightContainer"
      >
        <template #leftContent>
          <dx-data-grid
            :data-source="dataSourceConfig"
            @selection-changed="onSelectionChanged($event, rowSelect)"
          >
            <dx-column data-field="Code" caption="Code" sort-order="asc" />
          </dx-data-grid>
        </template>

        <template #rightContent>
          <DxToolbar class="split-view-toolbar">
            <DxItem
              :options="toolbar.back"
              location="before"
              widget="dxButton"
            />
            <DxItem #default location="center" locate-in-menu="never">
              <div class="toolbar-label">
                <b>{{ model.Name }}</b>
                &nbsp;
                <span>{{ model.Code }}</span>
              </div>
            </DxItem>
            <DxItem
              :options="toolbar.edit"
              location="after"
              locate-in-menu="auto"
              widget="dxButton"
              v-if="baseView.mode == 'review'"
            />
            <DxItem
              :options="toolbar.save"
              location="after"
              locate-in-menu="auto"
              widget="dxButton"
              v-if="baseView.mode != 'review'"
            />
          </DxToolbar>
          <div class="split-view-card responsive-paddings">
            <div class="dx-fieldset">
              <div class="dx-field">
                <div class="dx-field-label">Colour</div>
                <div class="dx-field-value">
                  <DxColorBox
                    :value.sync="model.Colour"
                    validation-message-mode="always"
                    :disabled="baseView.mode == 'review'"
                  ></DxColorBox>
                </div>
              </div>
            </div>
          </div>
        </template>
      </gc-split-view>
    </div>
  </gc-main-layout>
</template>

<script>
import { WorkOrderMaterialAvailabilityStatusService } from "../../_services/api/production/work-order-material-availability-status.service";

import BaseViewMixin from "../../v1/_mixins/base.view";

export default {
  props: {},
  mixins: [BaseViewMixin],
  data() {
    return {
      toolbar: {
        back: {
          icon: "arrowleft",

          onClick: () => {
            this.$router.push({
              path: "/work-order-material-availability-status",
            });
          },
        },
        edit: {
          icon: "edit",

          onClick: () => {
            this.$router.push({
              path: `/work-order-material-availability-status/edit/${this.baseView.id}`,
            });
          },
        },
        save: {
          icon: "floppy",
          onClick: () => {
            this.$logger.trackEventButtonClickSave();
            this.saveWorkOrderMaterialStatus();
          },
        },
      },
      model: {
        Code: "",
        Colour: "",
      },
    };
  },
  components: {},
  watch: {
    $route: {
      immediate: true,
      handler: "handleLocalRouteChange",
    },
  },
  computed: {
    dataSourceConfig() {
      return WorkOrderMaterialAvailabilityStatusService.dataSourceConfig(
        "api/WorkOrderMaterialAvailabilityStatus",
        {
          select: ["Code", "Colour", "RecordId"],
          sort: [{ selector: "Code", desc: false }],
        }
      );
    },
    tabs() {
      return [
        {
          text: "Work Order Material Availability Status",
          path: `/work-order-material-availability-status/review/${this.baseView.id}`,
        },
      ];
    },
    showLeftContainer() {
      return !(this.isXSmall && this.baseView.mode !== "");
    },
    showRightContainer() {
      return this.baseView.mode !== "";
    },
  },
  methods: {
    handleLocalRouteChange() {
      let that = this;
      if (this.baseView.mode === "review" || this.baseView.mode === "edit") {
        this.model.Code = this.baseView.id;
        this.getRecord().then((response) => {
          if (response.data.value.length > 0) {
            this.model.Code = response.data.value[0].Code;
            this.model.Colour = response.data.value[0].Colour;
            that.refreshView();
          }
        });
      }
    },
    async getRecord() {
      return WorkOrderMaterialAvailabilityStatusService.getByCode(
        this.baseView.id
      );
    },
    async saveWorkOrderMaterialStatus() {
      await WorkOrderMaterialAvailabilityStatusService.save({
        Code: this.model.Code,
        Colour: this.model.Colour,
      })
        // eslint-disable-next-line no-unused-vars
        .then((res) => {
          // eslint-disable-next-line no-console
          // this.$logger.debug("saveWorkOrderMaterialStatus", res);
          this.$notify("WorkOrderMaterialStatus saved successfully", "success");
          this.setIgnoreRouteChangeConfirmation();
          this.$router.push({
            path: `/work-order-material-availability-status/review/${this.model.Code}`,
          });
        })
        // eslint-disable-next-line no-unused-vars
        .catch((error) => {
          // eslint-disable-next-line no-console
          // this.$logger.debug("error", error);
          this.$notify("WorkOrderMaterialStatus saved Failed!", "error");
        });
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
